<template>
    <div
        class="tw-my-8"
    >
        <Heading
            :title="(isAsiInquiry ? 'Mit wie vielen Personen möchtest du ' : 'Mit wie vielen Personen möchtest Du ') + countryName + ' erleben?'"
            :size="isAsiInquiry ? 2 : 3"
            :class="{ '!tw-text-[32px] !tw-leading-[1.1] !tw-mt-24': isAsiInquiry }"
        />
        <NumberInputComponent
            :min="1"
            :label="$t('groupSize.grownups')"
            name="adultsValue"
            v-model.number="adults"/>
        <NumberInputComponent
            :min="0"
            :label="$t('groupSize.children')"
            name="childrenValue"
            v-model.number="children"/>
        <NumberInputComponent
            :min="0"
            :label="$t('groupSize.babies')"
            name="infantsValue"
            v-model.number="infants"/>
    </div>
</template>

<script>

import NumberInputComponent from "../UI/NumberInputComponent.vue";
import { mapGetters } from "vuex";

export default {
    name: "PersonCount",
    components: {NumberInputComponent},
    props: {
        countryName: String,
        required: true,
    },
    data: () => ({
        adults: 1,
        children: 0,
        infants: 0,
    }),
    computed: {
        ...mapGetters({
            isAsiInquiry: 'tour/isAsiInquiry',
        })
    },
    mounted() {
        if(this.$store.getters['tour/travelData'].groupSize.adults) {
            this.adults = this.$store.getters['tour/travelData'].groupSize.adults;
            this.children = this.$store.getters['tour/travelData'].groupSize.children;
            this.infants = this.$store.getters['tour/travelData'].groupSize.infants;
        }
        this.$store.commit('tour/setAdults', this.adults);
        this.$store.commit('tour/setChildren', this.children);
        this.$store.commit('tour/setInfants', this.infants);
    },
    watch: {
        adults: function (val) {
            this.$store.commit('tour/setAdults', val);
        },
        children: function (val) {
            this.$store.commit('tour/setChildren', val);
        },
        infants: function (val) {
            this.$store.commit('tour/setInfants', val);
        }
    }
}
</script>
